import {Occasion} from "./Occasion";
import {IOccasions} from "./IOccasions";
import {ISignal, SignalDispatcher} from "strongly-typed-events";
import {IEntity} from "../../../typescript-plugin/entities/IEntity";
import {Key} from "../../../typescript-plugin/entities/Key";
import {Serializables} from "../../../typescript-plugin/entities/Serializables";

export class Occasions extends Serializables<Occasion> implements IOccasions, IEntity{

    private updated:SignalDispatcher = new SignalDispatcher();

    public SetOccasions(occasions:Array<Occasion>){
        this.items = occasions;
    }

    public Key(): Key {
        return undefined;
    }

    public ToPersistable(): {} {
        return this.Serialize();
    }

    public ToEntity(data: {}): void {
        this.Deserialize(data);
    }

    public Updated(): ISignal {
        return this.updated;
    }

    protected CreateEntity(): Occasion {
        return new Occasion();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/occasion/Occasions.ts